import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: 'z-1 f-col items-start py-6 gap-6 md:(absolute bottom-0 mx-4 p-6 max-w-120)',
    ctaContainer: 'md:justify-end',
    grid: 'container'
  },
} satisfies CMSConfig['bannerOverlay']
